export enum WarehouseStatus {
  Created = "10",
  Active = "30",
  Inactive = "70",
}
